module.exports = __webpack_public_path__ + "img/research5.c1a23f3a.jpg";